import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { Link } from "react-router-dom";
import ComponentTitle from "../../layout/ComponentTitle";
import { getObjects } from "../../../utils/objects";
import { isNode } from "react-flow-renderer";

const BlocValeurAjoutee = (props) => {
  const { t } = useTranslation();
  const { idOrgunit, ReduxInstanceId, nomOrgunit, descriptionOrgunit, refreshDemande } = props;
  const [processes, setProcesses] = useState([]);
  const [arborescenceComplete, setArborescenceComplete] = useState([]);
  const [afficheValeurAjoutee, setAfficheValeurAjoutee] = useState(false);

  const creationArborescence = () => {
    var arborescence = [];
    processes
      .filter((item) => item.famille === "MacroProcess")
      .forEach((process) => {
        let node = {};
        node.id = process._id;
        node.nom = process.nom;
        node.orgunits = process.orgunits;
        if (process.view.length) {
          node.childrens = [];
        }
        arborescence.push(node);
        addRecursiveNode(node, process);
      });
    setArborescenceComplete(arborescence);
  };

  const addRecursiveNode = (noeudParent, process) => {
    var hasview = false;
    var enfantsIdentite = [];

    if (process.view) {
      hasview = true;
      const enfantsPrincipaux = [];
      for (const noeud of process.view) {
        if (isNode(noeud) && noeud.data.template === 0) {
          enfantsPrincipaux.push(noeud.data.process);
        }
      }
      enfantsPrincipaux.forEach((enfant) =>
        enfantsIdentite.push(processes.find((element) => element._id === enfant))
      );
    }

    if (hasview) {
      enfantsIdentite.forEach((enfant) => {
        let node = {};
        node.id = enfant._id;
        node.nom = enfant.nom;
        node.orgunits = enfant.orgunits;
        if (enfant.view.length) {
          node.childrens = [];
        }
        noeudParent.childrens.push(node);
        addRecursiveNode(node, enfant);
      });
    }
  };

  const RecursiveComponentLigneTableau = ({ objet, niveau }) => {
    const found = getObjects(objet, "", idOrgunit);
    if (!found.length) {
      return false;
    }
    if (found.length && !afficheValeurAjoutee) {
      setAfficheValeurAjoutee(true);
    }

    return (
      <div>
        <div
          className={`d-flex p-1 valeurAjouteeOrgUnitNiveau_${niveau}`}
          style={{ marginLeft: niveau * 20 + "px" }}
        >
          <Link to={`/processes/${objet.id}`}>{objet.nom}</Link>
        </div>
        {objet.childrens &&
          objet.childrens.map((enfant) => (
            <RecursiveComponentLigneTableau
              key={enfant.id}
              objet={enfant}
              detailView={enfant.childrens}
              niveau={niveau + 1}
            />
          ))}
      </div>
    );
  };

  const recupProcesses = async () => {
    const res = await apiGetProcesses(ReduxInstanceId);
    setProcesses(res.data);
  };

  useEffect(() => {
    creationArborescence();
  }, [processes]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    recupProcesses();
  }, [refreshDemande]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setAfficheValeurAjoutee(false);
  }, [idOrgunit]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {afficheValeurAjoutee && (
        <ComponentTitle
          title={t("public.componentOrgUnit.valeurAjoutee")}
          popupInfo={descriptionOrgunit}
          emulateH2="true"
        />
      )}
      <div className="valeurAjouteeOrgUnitContent">
        {arborescenceComplete.map((macroProcess) => (
          <RecursiveComponentLigneTableau key={macroProcess.id} objet={macroProcess} niveau={0} />
        ))}
      </div>
    </>
  );
};

export default BlocValeurAjoutee;
